import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SelectionCardItem } from '../Utils/Components/slection-card';
import placeholder from '../../assets/images/img.jpg';
import { setSelectedSection, setTab } from '../../redux/actions/sideBarAction';
import { useDispatch } from 'react-redux';
import Scrollbars from 'react-custom-scrollbars-2';
import { DataNotFoundAnimation } from '../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../Utils/LoadingAnimations/loadingAnimation';
import { useMutation, useQuery } from 'react-query';
import { globalEnv } from '../../config/baseConfig';
import axios from 'axios';
import { useTypedSelector } from '../../hooks/useTypeSelector';
import SaveButton from '../Utils/saveButton';
import Analytics from '../Sections/Analytics/analytics';
import LazyImage from '../Utils/Components/imageComponent';
import { ContribModal } from '../SubSections/Topic/changeCreator';
import { AddTopicModal } from './addTopic';
import { stateNotificationsEnum } from '../Utils/notification';
import { SetNotificationAction } from '../../redux/actions/notificationAction';
import { axiosInstance } from '../../config/axiosInstance';

export default function ExtensionSelectMenu() {
	const { id } = useParams();
	const [isChanged, setIsChanged] = useState(false);

	const [extensionName, setExtensionName] = useState('');
	const [extensionUrl, setExtensionUrl] = useState('');
	const [referralCode, setReferralCode] = useState('');
	const [usersCount, setUsersCount] = useState('');
	const [uninstallsCount, setUninstallsCount] = useState('');
	const [selectedTopicName, setSelectedTopicName] = useState('');
	const [topicId, setTopicId] = useState('');
	const [dailyImage, setDailyImage] = useState('');
	const [dailyImageLowRes, setDailyImageLowRes] = useState('');
	const [coverPic, setCoverPic] = useState<string>('');
	const [coverPicLowRes, setCoverPicLowRes] = useState<string>('');

	const [isSearchingTopics, setIsSearchingTopics] = useState(false);
	const [isModalChanged, setIsModalChanged] = useState(false);
	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [updatedTopic, setUpdatedTopic] = useState<any>();
	const [isSaving, setIsSaving] = useState(false);

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const dispatch = useDispatch();
	dispatch(setTab('extensions'));
	dispatch(setSelectedSection('Extension Main Menu'));

	const nameRef = useRef(null) as any;

	const { isLoading, isFetching, isError } = useQuery(
		['extensions', id],
		() => fetchExtensionDetails(),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	async function fetchExtensionDetails() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/extension/${id}/get-detailed`,
			config
		);

		setExtensionName(data.name);
		setExtensionUrl(data.url);
		setUsersCount(data.userCount);
		setUninstallsCount(data.uninstallCount);
		setTopicId(data.topic._id);
		setSelectedTopicName(data.topic.name);
		setDailyImage(data.topic.dailyImage.url);
		setDailyImageLowRes(data.topic.dailyImage.url_low_res);
		// setCoverPic(data.topic.coverPic.url);
		setCoverPicLowRes(data.topic.coverPic.url_low_res);

		return data;
	}

	const updateExtensionReq = async () => {
		const dto = {
			name: extensionName,
			topic: updatedTopic != null ? updatedTopic._id : topicId,
			url: extensionUrl
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance.put(
			globalEnv.BASE_URL + `/extension/${id}/update`,
			dto,
			config
		);
		return response;
	};

	const updateTopic = useMutation(updateExtensionReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated extension.'
				})
			);
		},
		onError: (error) => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	useEffect(() => {
		if (updatedTopic != null) {
			setCoverPic(updatedTopic.backgroundImage.url);
			setCoverPicLowRes(updatedTopic.backgroundImage.url_low_res);
			setSelectedTopicName(updatedTopic.name);
		}
	}, [updatedTopic]);

	const topicSearchRef = useRef(null) as any;

	return (
		<div className="content-container">
			<Scrollbars autoHide>
				{isLoading || isFetching ? (
					<LoadingAnimComponent />
				) : isError ? (
					<div className="h-full ">
						<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<main>
						<section className="relative block" style={{ height: '500px' }}>
							<div
								className="absolute top-0 w-full h-full bg-center bg-cover"
								style={{
									backgroundImage: `url('${coverPic ? coverPic : dailyImage}')`
								}}
							>
								<span
									id="blackOverlay"
									className="w-full h-full absolute opacity-50 bg-black"
								></span>
							</div>
						</section>
						<section className="relative py-16 bg-gray-400 dark:bg-gray-600 transition-all duration-500">
							<div className="container mx-auto px-4">
								<div
									className="relative flex flex-col bg-base-bg-light dark:bg-base-bg-dark
											transition-all duration-500 w-full shadow-xl rounded-lg -mt-96 h-fit"
								>
									<div className="flex lg:flex-row flex-col w-full justify-center">
										<div className=" w-1/12 lg:w-3/12" />

										<div
											className="flex self-center bg-gray-100 dark:bg-gray-700
											lg:rounded-b-xl w-full lg:w-8/12 xl:w-5/12 transition-all duration-500 shadow-lg"
										>
											<div className="w-full px-7">
												<div className="flex flex-row w-full">
													<div className="w-32 h-32 flex justify-center flex-shrink-0 align-middle self-center mr-3">
														<LazyImage
															photo={
																coverPicLowRes != null
																	? coverPicLowRes != null
																		? coverPicLowRes
																		: placeholder
																	: placeholder
															}
															style={
																'block object-cover object-center w-full aspect-[1/1] rounded-lg'
															}
														/>
													</div>
													<div className=" w-2/4">
														<div className="mt-2 mb-2">
															<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
																Extension name
															</label>
															<input
																className="inputStyle2"
																id="grid-last-name"
																type="text"
																placeholder="Extension Name"
																onChange={(e) => {
																	setExtensionName(e.target.value);
																	setIsChanged(true);
																}}
																value={extensionName}
															/>
														</div>
														<div className="mt-2 mb-2">
															<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
																Extension URL
															</label>
															<input
																className="inputStyle2"
																id="grid-last-name"
																type="text"
																placeholder="Extension URL"
																onChange={(e) => {
																	setExtensionUrl(e.target.value);
																	setIsChanged(true);
																}}
																value={extensionUrl}
															/>
														</div>
														<div className="mb-2">
															<div>
																<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
																	{updatedTopic != null
																		? 'Updated Selected Topic'
																		: 'Selected Topic'}
																</label>
																<input
																	className="inputStyle2"
																	id="grid-last-name"
																	type="text"
																	placeholder="Topic Name"
																	onClick={() => {
																		setIsSearchingTopics(!isSearchingTopics);
																	}}
																	ref={topicSearchRef}
																	value={selectedTopicName}
																/>
															</div>
														</div>

														<ContribModal
															visible={isSearchingTopics}
															setModalOpen={setIsSearchingTopics}
															isChanged={isModalChanged}
															setIsChanged={setIsModalChanged}
															isWarnModalOpen={isWarnModalOpen}
															setIsWarnModalOpen={setIsWarnModalOpen}
														/>
														{isSearchingTopics && (
															<div className="absolute -mt-20 pt-0.5 z-30 w-[55%]">
																<AddTopicModal
																	buttonRef={topicSearchRef}
																	isModalOpen={isSearchingTopics}
																	setIsModalOpen={setIsSearchingTopics}
																	setTopic={setUpdatedTopic}
																	setIsChanged={setIsChanged}
																	searchTerm={selectedTopicName}
																	setSearchTerm={setSelectedTopicName}
																/>
															</div>
														)}
													</div>

													<div className="grid grid-cols-1 self-center ml-auto space-y-2">
														<div>
															<button
																className="btn btn-outline btn-sm btn-error w-[82px]"
																type="button"
																style={{ transition: 'all .15s ease' }}
																// onClick={() => setIsRemoveModalOpen(true)}
															>
																Delete
															</button>
														</div>
														<div>
															{isChanged && (
																<SaveButton
																	isSaving={isSaving}
																	saveFunc={updateTopic.mutate}
																/>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>

										<div
											className="flex  bg-gray-100 dark:bg-gray-700 rounded-br-xl rounded-bl-xl
											w-full lg:w-3/12 transition-all duration-500 shadow-lg lg:ml-10 h-32"
										>
											<div className="w-full px-7">
												<div className="flex flex-col w-full">
													<div className=" w-full">
														<div className="mt-2 mb-2">
															<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
																Referral code
															</label>
															<input
																className="inputStyle2"
																id="grid-last-name"
																type="text"
																placeholder="Referral Code"
																onChange={(e) => {
																	setReferralCode(e.target.value);
																}}
																value={referralCode}
															/>
														</div>
													</div>

													<div className="self-center ml-auto ">
														<button
															className="btn btn-outline btn-sm btn-primary w-[145px]"
															type="button"
															style={{ transition: 'all .15s ease' }}
															onClick={() => {
																navigator.clipboard.writeText(
																	referralCode != null
																		? `https://meavana.com?ext-id=${id}&rc=${referralCode}&ext-name=${extensionName}&ext-url=${extensionUrl}`
																		: `https://meavana.com?ext-id=${id}&ext-name=${extensionName}&ext-url=${extensionUrl}`
																);

																dispatch(
																	SetNotificationAction({
																		type: stateNotificationsEnum.SUCCESS,
																		message:
																			'Extension URL copied to clipboard.'
																	})
																);
															}}
														>
															Create referral
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="grid grid-cols-1 md:grid-cols-3 content-center mt-10 w-10/12 self-center">
										<SelectionCardItem
											name="User Data"
											sec={`${usersCount} Users`}
											path={`../extensions/${id}/users`}
											imgPath={placeholder}
										/>
										<SelectionCardItem
											name="Uninstall data"
											sec={`${uninstallsCount} Uninstalls`}
											path={`../extensions/${id}/uninstalls`}
											imgPath={placeholder}
										/>
										<SelectionCardItem
											name="Referred signups"
											sec="5 Referrals"
											path="./all-campaigns"
											imgPath={placeholder}
										/>
									</div>
									<div className="-mt-5 mb-5">
										<Analytics />
									</div>
								</div>
							</div>
						</section>
					</main>
				)}
			</Scrollbars>
		</div>
	);
}
